import { useEffect, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import CoreStaffService from '../../../services/CoreStaffService';
import { auditActionText, staffErrorText } from './staffText';

const formatWhen = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleString('es-UY', { dateStyle: 'short', timeStyle: 'short' });
};

/** Quién hizo qué sobre el personal (las últimas 200 acciones). */
const StaffAuditDialog = ({ open, onClose }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return undefined;
    let active = true;
    setLoading(true);
    setError('');
    CoreStaffService.audit({ limit: 200 })
      .then((data) => { if (active) setEntries(Array.isArray(data) ? data : []); })
      .catch((err) => { if (active) setError(staffErrorText(err, 'No se pudo cargar la auditoría.')); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Auditoría del personal</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error">{error}</Alert>}
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress size={28} /></Box>
        ) : entries.length === 0 && !error ? (
          <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>Todavía no hay movimientos.</Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Cuándo</TableCell>
                <TableCell>Quién</TableCell>
                <TableCell>Qué hizo</TableCell>
                <TableCell>Sobre</TableCell>
                <TableCell>Detalle</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {entries.map((entry) => (
                <TableRow key={entry.id}>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatWhen(entry.createdAt)}</TableCell>
                  <TableCell>{entry.actorEmail}</TableCell>
                  <TableCell>{auditActionText(entry.action)}</TableCell>
                  <TableCell>{entry.targetEmail || '-'}</TableCell>
                  <TableCell>{entry.detail || '-'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions><Button onClick={onClose}>Cerrar</Button></DialogActions>
    </Dialog>
  );
};

export default StaffAuditDialog;
